module.exports = __webpack_public_path__ + "img/plant_2_mobile.f2fe78ad.webp";